// Mede a largura de um elemento (ResizeObserver) para desenhar SVGs
// responsivos sem distorção: o viewBox usa a largura real em px, então
// 1 unidade = 1px (sem esticar texto nem letterbox).

import { useEffect, useRef, useState } from 'react'

export function useContainerWidth<T extends HTMLElement>(): [React.RefObject<T | null>, number] {
  const ref = useRef<T>(null)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    // O ResizeObserver dispara uma vez ao começar a observar (tamanho atual),
    // então não é preciso setState síncrono aqui.
    const ro = new ResizeObserver(entries => {
      for (const e of entries) setWidth(e.contentRect.width)
    })
    ro.observe(el)
    return () => ro.disconnect()
  }, [])

  return [ref, width]
}
